import { callApi } from "./Api";
// import { getSeconds } from "date-fns";

export const GETROLE = "GETROLE";
export const GETCLIENTROLES = "GETCLIENTROLES";
export const SENDINVITE = "SENDINVITE";
export const SENDCLIENTINVITE = "SENDCLIENTINVITE";
export const SET_STATUS_TO_FALSE = "SET_STATUS_TO_FALSE";
export const GET_TABLE_LIST = "GET_TABLE_LIST";
export const UPDATE_PROFILE = "UPDATE_PROFILE";
export const ROLLBACK_UPDATE_STATUS = "ROLLBACK_UPDATE_STATUS";
export const UPDATE_ROLE = "UPDATE_ROLE";
export const SUSPEND_USER = "SUSPEND_USER";
export const CLIENT_ASSIGNMENTS = "CLIENT_ASSIGNMENTS";
export const REASSIGN_ACCOUNT_MANAGER = "REASSIGN_ACCOUNT_MANAGER";
export const REASSIGN_ROLL_BACK = "REASSIGN_ROLL_BACK";
export const TEAM_MEMBER_OPTIONS = "TEAM_MEMBER_OPTIONS";
export const ACCOUNT_MANAGER = "ACCOUNT_MANAGER";
export const CLEAR_SUSPEND_ERROR = "CLEAR_SUSPEND_ERROR";

export const getRoles = () => (dispatch, getState) => {
  let url = "roles/internal-options";
  callApi(dispatch, getState, GETROLE, url);
};

export const getClientRoles = () => (dispatch, getState) => {
  const url = "roles/client-options";
  callApi(dispatch, getState, GETCLIENTROLES, url);
};

export const rollBackUpdateStatus = () => ({
  type: ROLLBACK_UPDATE_STATUS,
  value: false,
});
export const rollBackStatus = () => ({
  type: SET_STATUS_TO_FALSE,
  value: false,
});
export const rollBackReassign = () => ({
  type: REASSIGN_ROLL_BACK,
  value: false,
});

export const sendInvite = obj => (dispatch, getState) => {
  let url = "invitations/internal";
  callApi(dispatch, getState, SENDINVITE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const sendClientUserInvite = obj => (dispatch, getState) => {
  const url = "invitations/client-to-client";
  callApi(dispatch, getState, SENDCLIENTINVITE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const getTableList = (obj, clientId) => (dispatch, getState) => {
  let url =
    clientId && clientId !== "undefined"
      ? `clients/${clientId}/users`
      : `users/internal`;
  callApi(dispatch, getState, GET_TABLE_LIST, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const updateProfile = (id, obj) => (dispatch, getState) => {
  let url = `users/${id}/update`;
  callApi(dispatch, getState, UPDATE_PROFILE, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};

export const updateRole = (userId, roleId, isUpdateClient) => (
  dispatch,
  getState,
) => {
  let url;
  if (isUpdateClient === true) {
    url = `users/${userId}/update-client-role-to/${roleId}`;
  } else {
    if (/system administrator/gi.test(getState().app.roleName)) {
      url = `users/${userId}/update-role-to/${roleId}`;
    } else if (/administrator/gi.test(getState().app.roleName)) {
      url = `users/${userId}/update-client-role-to/${roleId}`;
    }
  }

  callApi(dispatch, getState, UPDATE_ROLE, url, {
    method: "POST",
  });
};

// below is for user status component
export const suspendUser = (userId, status, isClientUser = false) => (
  dispatch,
  getState,
) => {
  let url;
  if (isClientUser === true) {
    if (
      /^(\/clients\/edit\/Business-Units\/detail\/Business Unit Team Members|\/clients\/edit\/Client-Team-Members\/user-status)/g.test(
        getState().routing.location.pathname,
      )
    ) {
      if (
        /^(system administrator|account manager)/gi.test(
          getState().app.roleName,
        )
      ) {
        url = `users/${userId}/${status}/client`;
      } else {
        url = `users/${userId}/${status}/business-unit-team-member`;
      }
    } else {
      url = `users/${userId}/${status}/client`;
    }
  } else {
    if (/^administrator/gi.test(getState().app.roleName)) {
      url = `users/${userId}/${status}/client`;
    } else if (
      /^(system administrator|account manager)/gi.test(
        getState().app.roleName,
      ) &&
      !/^\/client\/edit\/Business-Units\/detail\/Business Unit Team Members/g.test(
        getState().routing.location.pathname,
      )
    ) {
      url = `users/${userId}/${status}`;
    }
  }

  callApi(dispatch, getState, SUSPEND_USER, url, {
    method: "POST",
  });
};

export const getClientAssignments = id => (dispatch, getState) => {
  let url;
  if (/^system administrator/gi.test(getState().app.roleName)) {
    url = `users/${id}/clients`;
  } else if (/^administrator/gi.test(getState().app.roleName)) {
    url = `users/${id}/business-units`;
  }
  callApi(dispatch, getState, CLIENT_ASSIGNMENTS, url);
};

export const reassingAccountManager = (id, obj) => (dispatch, getState) => {
  let url;
  if (/^system administrator/gi.test(getState().app.roleName)) {
    url = `users/${id}/clients/reassign`;
  } else if (/^(administrator|team member)/gi.test(getState().app.roleName)) {
    url = `users/${id}/business-units/reassign`;
  }
  callApi(dispatch, getState, REASSIGN_ACCOUNT_MANAGER, url, {
    method: "POST",
    body: JSON.stringify(obj),
  });
};
export const getAccountManage = id => (dispatch, getState) => {
  let url;
  if (/^system administrator/gi.test(getState().app.roleName)) {
    url = `commons/account-manager-options`;
  } else if (/^administrator/gi.test(getState().app.roleName)) {
    url = `clients/${id}/team-member-options`;
  }
  callApi(dispatch, getState, ACCOUNT_MANAGER, url);
};

export const clearSuspendError = () => ({ type: CLEAR_SUSPEND_ERROR });



// WEBPACK FOOTER //
// ./src/actions/employees.js